import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { Spinner } from '../Spinner/Spinner.js';
import style from './Button.module.css.js';

const Button = forwardRef(({ variant = "primary", loading, children, ...attrs }, ref) => {
    return (jsxs("button", { type: "button", ...attrs, disabled: loading || attrs.disabled, ref: ref, className: classNames(style.button, style[variant], loading && style.loading, attrs.className), children: [loading && jsx(Spinner, { size: 18, className: style.spinner }), children] }));
});
Button.displayName = "Button";
const ButtonIconWithLabel = ({ icon, label, }) => {
    return (jsxs("div", { className: style.buttonIconWithLabel, children: [icon, jsx("span", { children: label })] }));
};

export { Button, ButtonIconWithLabel };
//# sourceMappingURL=Button.js.map
